
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import baze1 from '../imagesHome/baze1.png';
import baze2 from '../imagesHome/baze2.png';
import baze3 from '../imagesHome/baze3.png';
import baze4 from '../imagesHome/baze4.png';
import baze5 from '../imagesHome/basr5.png';

import financiaraImage from '../imagesHome/conti.png';

import './ChooseYourCourse.css';

const courses = [
  {
    id: 'bazele',
    label: 'Bazele contabilitatii',
    description:
      'Intelege activele, datoriile, capitalurile proprii si logica operatiunilor contabile.',
    images: [baze1, baze2, baze3, baze4, baze5],
    syllabusUrl: '/cursuri/bazele-contabilitatii',
    available: true
  },
  {
    id: 'financiara',
    label: 'Contabilitate financiara',
    description:
      'Descopera cum se inregistreaza operatiunile unei firme si cum functioneaza conturile contabile.',
    images: [financiaraImage],
    syllabusUrl: '/cursuri/contabilitate-financiara',
    available: true
  },
  {
    id: 'primara',
    label: 'Contabilitate primara',
    description:
      'Invata sa intelegi si sa verifici documentele folosite in activitatea zilnica a unei firme.',
    images: [],
    syllabusUrl: '/cursuri/contabilitate-primara',
    available: false
  },
  {
    id: 'aplicata',
    label: 'Contabilitate aplicata',
    description:
      'Pune cunostintele in practica prin situatii concrete si exercitii care leaga mai multe notiuni.',
    images: [],
    syllabusUrl: '/cursuri/contabilitate-aplicata',
    available: false
  }
];

export default function ChooseYourCourse() {
  const [activeId, setActiveId] = useState('bazele');
  const [slideIndex, setSlideIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [reducedMotion, setReducedMotion] = useState(false);

  const activeCourse =
    courses.find(course => course.id === activeId) ||
    courses[0];

  const activeImages = activeCourse.images;

  const selectCourse = (courseId) => {
    if (!courses.some(course => course.id === courseId)) {
      return;
    }

    setActiveId(courseId);
    setSlideIndex(0);
    setIsPaused(false);
  };

  // Conectare cu CourseBar

  useEffect(() => {
    const handleSelection = (event) => {
      selectCourse(event.detail?.courseId);
    };

    window.addEventListener(
      'contalearn:select-course',
      handleSelection
    );

    return () => {
      window.removeEventListener(
        'contalearn:select-course',
        handleSelection
      );
    };
  }, []);

  // Respecta preferintele de accesibilitate

  useEffect(() => {
    const media = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    const updateMotion = () => {
      setReducedMotion(media.matches);
    };

    updateMotion();

    media.addEventListener('change', updateMotion);

    return () => {
      media.removeEventListener('change', updateMotion);
    };
  }, []);

  // Schimbare automata la fiecare 4 secunde

  useEffect(() => {
    if (
      activeImages.length <= 1 ||
      isPaused ||
      reducedMotion
    ) {
      return;
    }

    const interval = window.setInterval(() => {
      setSlideIndex(current =>
        (current + 1) % activeImages.length
      );
    }, 4000);

    return () => window.clearInterval(interval);
  }, [
    activeId,
    activeImages.length,
    isPaused,
    reducedMotion
  ]);

  return (
    <section
      id="choose-your-course"
      className="cl-paths"
      aria-labelledby="cl-paths-title"
    >
      <div className="cl-paths__inner">

        <div className="cl-paths__main">

          {/* STANGA */}

          <div className="cl-paths__left">

            <h2
              id="cl-paths-title"
              className="cl-paths__title"
            >
              Tu alegi ce vrei sa inveti
            </h2>

            <p className="cl-paths__intro">
              Incepi cu bazele sau aprofundezi un
              subiect? Descopera cursul potrivit
              obiectivului tau.
            </p>

            <div
              className="cl-paths__selector"
              role="group"
              aria-label="Alege cursul"
            >
              {courses.map(course => (
                <button
                  key={course.id}
                  type="button"
                  className="cl-paths__option"
                  aria-pressed={activeId === course.id}
                  onClick={() => selectCourse(course.id)}
                >
                  {course.label}
                </button>
              ))}
            </div>

          </div>

          {/* DREAPTA */}

          <div className="cl-paths__right">

            <div className="cl-paths__panel">

              <div className="cl-paths__panel-header">

                <span className="cl-paths__panel-name">
                  {activeCourse.label}
                </span>

              </div>

              <div className="cl-paths__panel-body">

                {/* GALERIE / IN DEZVOLTARE */}

                <div
                  className="cl-paths__gallery"
                  onMouseEnter={() => setIsPaused(true)}
                  onMouseLeave={() => setIsPaused(false)}
                  onFocusCapture={() => setIsPaused(true)}
                  onBlurCapture={(event) => {
                    if (
                      !event.currentTarget.contains(
                        event.relatedTarget
                      )
                    ) {
                      setIsPaused(false);
                    }
                  }}
                >

                  <div className="cl-paths__image-container">

                    {!activeCourse.available ? (

                      <div
                        className="cl-paths__coming-soon"
                        role="status"
                      >
                        <div
                          className="cl-paths__coming-soon-icon"
                          aria-hidden="true"
                        >
                          🚧
                        </div>

                        <h3>În dezvoltare</h3>

                        <p>
                          Pregătim acest curs pentru tine.
                          Revino în curând!
                        </p>
                      </div>

                    ) : (

                      <img
                        key={`${activeId}-${slideIndex}`}
                        src={activeImages[slideIndex]}
                        alt={
                          `Exercitiu demonstrativ - ` +
                          activeCourse.label
                        }
                        className={
                          'cl-paths__image ' +
                          (
                            activeId === 'bazele'
                              ? 'cl-paths__image--bazele'
                              : ''
                          )
                        }
                        draggable="false"
                      />

                    )}

                  </div>

                  {/* BULINE SUB IMAGINE */}

                  {activeCourse.available &&
                    activeImages.length > 1 && (

                    <div
                      className="cl-paths__dots"
                      role="group"
                      aria-label="Navigare galerie"
                    >
                      {activeImages.map((_, index) => (
                        <button
                          key={index}
                          type="button"
                          className={
                            'cl-paths__dot ' +
                            (
                              slideIndex === index
                                ? 'cl-paths__dot--active'
                                : ''
                            )
                          }
                          aria-label={`Imaginea ${index + 1}`}
                          aria-pressed={slideIndex === index}
                          onClick={() => setSlideIndex(index)}
                        />
                      ))}
                    </div>

                  )}

                </div>

              </div>

            </div>

          </div>

        </div>

        {/* BANNER INFERIOR */}

        <div className="cl-paths__banner">

          <div className="cl-paths__banner-copy">

            <h3>Exploreaza toate cursurile</h3>

            <p>
              Descopera lectiile ContaLearn si alege
              urmatorul pas in invatarea contabilitatii.
            </p>

          </div>

          <Link
            to="/cursuri-prezentare"
            className="cl-paths__banner-button"
          >
            Toate cursurile
          </Link>

        </div>

      </div>
    </section>
  );
}
